
/* styles */
require("!!./../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../node_modules/vue-loader/lib/style-rewriter?id=data-v-990a97bc!./../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")

var Component = require("!./../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!./../node_modules/vue-loader/lib/template-compiler?id=data-v-990a97bc!./../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 237
// module chunks = 1